import { ENV } from '@/constants';
import { exploreSchemaItemList } from '../exploreSchema';

export const schemaObject_ImageToDrawing = {
	'@context': 'https://schema.org',
	'@graph': [
		{
			'@type': 'WebPage',
			'@id': 'https://liftapp.ai/image-to-drawing',
			name: 'Image to Drawing — AI Drawing Converter | Lift',
			description:
				"Convert photo to drawing instantly. Lift's AI Drawing filter. No watermark. Upload, apply, and share realistic hand-drawn portraits. Try now!",
			url: 'https://liftapp.ai/image-to-drawing',
			image: 'https://liftapp.ai/seo-image.webp',
			mainEntity: [
				{ '@id': 'https://liftapp.ai/image-to-drawing#product' },
				{ '@id': 'https://liftapp.ai/image-to-drawing#howto' },
				{ '@id': 'https://liftapp.ai/image-to-drawing#benefits' },
				{ '@id': 'https://liftapp.ai/image-to-drawing#faq' },
				{ '@id': 'https://liftapp.ai/image-to-drawing#why-lift' },
				{ '@id': 'https://liftapp.ai/image-to-drawing#explore-tools' },
				{ '@id': 'https://liftapp.ai/image-to-drawing#all-in-one' },
			],
		},
		// product
		{
			'@type': 'Product',
			'@id': 'https://liftapp.ai/image-to-drawing#product',
			name: 'Transform Photos into Pencil Drawings',
			description:
				'Instantly turn your photos into hand-drawn pencil sketches with AI — no artistic skills needed. Perfect for social media avatars, unique posts, or showcasing your creative side with realistic graphite-style portraits!',
			url: 'https://liftapp.ai/image-to-drawing',
			fileFormat: ['image/jpeg', 'image/png', 'image/webp'],
			memoryRequirements: 'Max file size: 20MB',
			brand: {
				'@type': 'Brand',
				name: 'Lift',
			},
			aggregateRating: {
				'@type': 'AggregateRating',
				ratingValue: '4.8',
				reviewCount: 130000,
				bestRating: '5',
				worstRating: '1',
			},
			interactionStatistic: [
				{
					'@type': 'InteractionCounter',
					interactionType: { '@type': 'InstallAction' },
					userInteractionCount: 13000000,
				},
			],
		},
		// howto
		{
			'@type': 'HowTo',
			'@id': 'https://liftapp.ai/image-to-drawing#howto',
			name: 'How it works',
			step: [
				{
					'@type': 'HowToStep',
					position: 1,
					name: 'Upload your photos',
					text: "Choose a photo from your device or take one using Lift's app",
				},
				{
					'@type': 'HowToStep',
					position: 2,
					name: 'AI applies the drawing effect',
					text: 'Instantly convert your photo into hand-drawn effect',
				},
				{
					'@type': 'HowToStep',
					position: 3,
					name: 'Customize adjustments',
					text: 'Fine-tune your image with easy-to-use editing tools',
				},
				{
					'@type': 'HowToStep',
					position: 4,
					name: 'Download and use',
					text: 'Download your image or publish it straight to your social feeds',
				},
			],
		},
		// benefit
		{
			'@type': 'ItemList',
			'@id': 'https://liftapp.ai/image-to-drawing#benefits',
			name: 'Who Can Benefit from AI Picture to Drawing Converter?',
			description:
				"Lift's AI Picture to Drawing Converter is useful for artists, designers, social media creators, students, educators, and content marketers who want to transform photos into artistic hand-drawn sketches.",
			itemListOrder: 'Unordered',
			itemListElement: [
				{
					'@type': 'ListItem',
					position: 1,
					name: 'Perfect for artists and designers exploring hand-drawn aesthetics without manual sketching',
				},
				{
					'@type': 'ListItem',
					position: 2,
					name: 'Social media creators stand out with artistic, vintage-inspired posts',
				},
				{
					'@type': 'ListItem',
					position: 3,
					name: 'Students and educators can visualize concepts with clean, sketch-style imagery',
				},
				{
					'@type': 'ListItem',
					position: 4,
					name: 'Content marketers create eye-catching visuals that feel handcrafted and authentic',
				},
				{
					'@type': 'ListItem',
					position: 5,
					name: 'Quick, creative, and premium-quality — ideal for personal fun or online branding',
				},
			],
			image: {
				'@type': 'ImageObject',
				contentUrl:
					'https://liftapp.ai/_next/static/media/benefits.3da6de53.webp',
				name: 'AI Picture to Drawing Converter by Lift',
				description:
					'Example of how Lift AI Picture to Drawing Converter transforms photos into artistic hand-drawn sketches.',
			},
		},

		// faq
		{
			'@type': 'FAQPage',
			'@id': 'https://liftapp.ai/image-to-drawing#faq',
			mainEntity: [
				{
					'@type': 'Question',
					name: 'What is Lift Image to Drawing Converter?',
					acceptedAnswer: {
						'@type': 'Answer',
						text: "Lift's AI-powered photo to drawing converter is an online tool that transforms your photos into realistic pencil sketches — complete with soft shading, graphite texture, and hand-drawn details. Perfect for social media, prints, or creative projects.",
					},
				},
				{
					'@type': 'Question',
					name: 'How does the picture to drawing AI work?',
					acceptedAnswer: {
						'@type': 'Answer',
						text: 'Our AI analyzes your photo, identifies facial features and contours, then recreates it as a detailed drawing with natural cross-hatching, delicate gradients, and visible pencil strokes. The entire conversion happens automatically in seconds — no manual editing required.',
					},
				},
				{
					'@type': 'Question',
					name: 'Can I convert any image to drawing with AI?',
					acceptedAnswer: {
						'@type': 'Answer',
						text: "Yes. Lift works beautifully with portraits, selfies, group photos, pets, and more. The AI adapts to your photo's content and applies realistic pencil sketch effects that emphasize depth, texture, and artistic detail while preserving the essence of your original image.",
					},
				},
				{
					'@type': 'Question',
					name: 'Can I download the pencil drawing without a watermark?',
					acceptedAnswer: {
						'@type': 'Answer',
						text: "Absolutely. All images generated or edited in Lift can be exported without watermark when you're on the Pro plan. Download them in high-res PNG or JPG — ready for social media, print, framing, or gifts.",
					},
				},
			],
		},

		// why lift
		{
			'@type': 'ItemList',
			'@id': 'https://liftapp.ai/image-to-drawing#why-lift',
			name: "Why Lift's AI Image to Drawing Converter stands out",
			description:
				"Lift's Image to Drawing Converter combines professional-grade AI, ease of use, and affordability — making it a trusted choice for millions of users worldwide.",
			itemListOrder: 'Unordered',
			itemListElement: [
				{
					'@type': 'ListItem',
					position: 1,
					name: 'High-quality results',
					description:
						'AI-powered technology delivers professional-grade visuals every time',
				},
				{
					'@type': 'ListItem',
					position: 2,
					name: 'Intelligent rendering',
					description:
						'AI tailors the effect to the scene and subject for optimal results',
				},
				{
					'@type': 'ListItem',
					position: 3,
					name: 'Cross-platform support',
					description: 'Available on iOS, Android, and Web for seamless access',
				},
				{
					'@type': 'ListItem',
					position: 4,
					name: 'Budget-friendly',
					description:
						'Save on costly designers with an affordable and intuitive tool',
				},
			],
			image: {
				'@type': 'ImageObject',
				contentUrl:
					'https://liftapp.ai/_next/static/media/whyUse.ae83a89c.webp',
				name: 'Photo To Drawing Converter',
				description: 'Photo To Drawing Converter',
			},
		},
		// explore
		{
			'@type': 'ItemList',
			'@id': 'https://liftapp.ai/image-to-drawing#explore-tools',
			name: 'Explore the AI tools',
			description:
				'A curated list of AI-powered tools for image generation, enhancement, background removal, and more – all available on Lift.',
			itemListOrder: 'Unordered',
			...exploreSchemaItemList,
		},

		{
			'@type': 'SoftwareApplication',
			'@id': 'https://liftapp.ai/image-to-drawing#all-in-one',
			name: 'Try Lift – AI Content Creation Tools',
			description:
				'Your all-in-one tools to create, edit, and elevate your content. Create stunning content with AI tools, templates, and editing features effortlessly.',
			operatingSystem: 'iOS, Android, Web',
			applicationCategory: 'MultimediaApplication',
			url: `${ENV.LIFT_WEB_APP_URL}/sign-in?auto_login=true`,
			applicationSubCategory: 'Content Creation',
			publisher: {
				'@type': 'Organization',
				name: 'Lift',
				url: 'https://liftapp.ai',
			},
			potentialAction: [
				{
					'@type': 'ViewAction',
					name: 'Open Web App',
					target: `${ENV.LIFT_WEB_APP_URL}/sign-in?auto_login=true`,
				},
			],
		},

		{
			'@type': 'BreadcrumbList',
			itemListElement: [
				{
					'@type': 'ListItem',
					position: 1,
					name: 'Home',
					item: 'https://liftapp.ai',
				},
				{
					'@type': 'ListItem',
					position: 2,
					name: 'Image to Drawing',
					item: 'https://liftapp.ai/image-to-drawing',
				},
			],
		},
	],
};
